// eslint-disable-next-line @typescript-eslint/no-var-requires
const sanitizeHtml = require('sanitize-html');

const sanitizeHtmlConfig = {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'img',
    'span',
    'u',
    's',
    'ol',
    'ul',
    'li',
    'a',
  ]),
  allowedAttributes: {
    a: ['href', 'name', 'target'],
    img: ['src'],
    '*': ['style'],
  },
  allowedStyles: {
    '*': {
      'text-decoration': [/^line-through$/, /^underline$/],
    },
  },
};

export const sanitizeContent = (content: string) => {
  return sanitizeHtml(content, sanitizeHtmlConfig);
};
